var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-badge",class:_vm.classes},[_c('BnIcon',{staticClass:"icon-badge__icon",attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }